export const QUERY_KEY = {
  USER: "user",
  ADMIN_MERCHANT: "admin-merchant",
  PAYMENT_CHANNELS: "payment-channels",
  TRANSACTIONS: "transactions",
  ADMIN_EXCHANGE_RATE: "admin-exchange-rate",
  ADMIN_API_KEY: "admin-api-key",
  ADMIN_CURRENCY: "admin-currency",
  ADMIN_DASHBOARD_OVERVIEW: "admin-dashboard-overview",
  ADMIN_DASHBOARD_AREA: "admin-dashboard-area",
  ADMIN_DASHBOARD_PIE: "admin-dashboard-pie",
  ADMIN_DASHBOARD_STATS: "admin-dashboard-stats",
};
